import { BaseQueryFn, createApi } from "@reduxjs/toolkit/query/react";
import { API_BASE } from "../settings";
import axios, { AxiosError, AxiosRequestConfig } from "axios";

const axiosBaseQuery = ({ baseUrl }: { baseUrl: string } = { baseUrl: "" }): BaseQueryFn<
    {
        url: string
        method?: AxiosRequestConfig["method"]
        data?: AxiosRequestConfig["data"]
        params?: AxiosRequestConfig["params"]
        headers?: AxiosRequestConfig["headers"]
    },
    unknown,
    unknown
> =>
    async ({ url, method, data, params, headers }) => {
        try {
            const result = await axios({
                url: baseUrl + url,
                method,
                data,
                params,
                headers,
            })
            return { data: result.data, meta: result }
        } catch (axiosError) {
            const err = axiosError as AxiosError
            return {
                error: {
                    status: err.response?.status,
                    data: err.response?.data || err.message,
                },
            }
        }
    }

const emptySplitApi = createApi({
    baseQuery: axiosBaseQuery({
        baseUrl: API_BASE,
    }),
    tagTypes: ["players", "cards", "cards-items", "payments", "wager", "hall-wager", "hall-config", "payments-balances", "env", "games", "packages", "packageGames", "jackpots"],
    endpoints: () => ({}),
});

export default emptySplitApi;
